import axios, { AxiosError } from 'axios';
import { Auth } from '../pages/MainPage';
import {
  errorNotify,
  uniqueErrorNotify,
} from '../components/NotificationsEmitter';

let clientOptions = {
  withCredentials: true,
  baseURL: '/web',
  headers: {
    'Access-Control-Allow-Origin': 'https://dev.a.is.mv1f.ru/',
  },
};

if (process.env.REACT_APP_BASE_URL !== undefined) {
  clientOptions['baseURL'] = process.env.REACT_APP_BASE_URL;
}

export const client = axios.create(clientOptions);

client.interceptors.response.use(
  undefined,
  (error: AxiosError): Promise<AxiosError> => {
    if (error && error.response) {
      const data: any = error.response.data;
      const msg =
        (data && (data.message || data.error || data.error_description)) ||
        (typeof data === 'string' ? data : null) ||
        `Ошибка ${error.response.status}`;
      // Skip noisy Spring default when message is empty placeholder
      const text =
        msg && String(msg) !== 'No message available'
          ? String(msg)
          : `Ошибка ${error.response.status}`;
      if (error.response.status === 401) {
        Auth.auth = false;
        uniqueErrorNotify(
          'Сессия истекла',
          text ||
            'Для этого ресурса требуется полная авторизация. Войдите снова — несохранённые данные формы могут быть потеряны.'
        );
      } else {
        errorNotify('Ошибка', text);
      }
    }
    return Promise.reject(error);
  }
);
